export const newLoop = {
  name: 'Untitled Beet',
  bpm: 220,
  gridSize: 16,
  precision: 1,
  pads: [],
  trackList: {},
  trackCounter: 0,
  soloedTracks: [],
};

export const buttonText = 'Fresh Beet';

export const newLoopButtonSx = {
  fontSize: 20,
  fontWeight: 'bold'
};